import { useFeatureFlags } from '../contexts/FeatureFlagContext';

/**
 * Component that conditionally renders children based on feature flag status
 * @param {string} feature - The feature flag name to check
 * @param {ReactNode} children - Content to render when feature is enabled
 * @param {ReactNode} fallback - Optional content to render when feature is disabled
 * @param {boolean} showPro - Whether to show a "PRO" indicator when disabled
 */
export default function FeatureGate({ 
  feature, 
  children, 
  fallback = null,
  showPro = false 
}) {
  const { isFeatureEnabled, loading } = useFeatureFlags();
  
  // Don't render anything while loading
  if (loading) {
    return null;
  }
  
  const enabled = isFeatureEnabled(feature);
  
  if (enabled) {
    return children;
  }
  
  // Show PRO indicator if requested and no custom fallback
  if (showPro && !fallback) {
    return (
      <div style={{ 
        opacity: 0.5, 
        position: 'relative',
        pointerEvents: 'none'
      }}>
        {children}
        <span style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: '#1976d2',
          color: 'white',
          padding: '4px 8px',
          borderRadius: '4px',
          fontSize: '12px',
          fontWeight: 'bold',
          zIndex: 1
        }}>
          PRO
        </span>
      </div>
    );
  }
  
  return fallback;
}